/*
 * @Description:
 */

import { ActionTree, ActionContext } from 'vuex'
import { RootState } from '@/store'
import { PermissionState } from './state'
import { Mutations } from './mutations'
import { PermissionMutationType } from './mutation-types'
import { PermissionActionType } from './action-types'
import { asyncRoutes } from '@/router'
import { RouteRecordRaw } from 'vue-router'
// import { UserMenuModel } from '@/model/userModel'
// import { RootObject } from '@/model/rootObject'
// import { getCurrentUserMenu } from '@/apis/user'
// import { formatRouters } from '@/utils/util'

type AugmentedActionContext = {
    commit<K extends keyof Mutations>(
      key: K,
      payload: Parameters<Mutations[K]>[1],
    ): ReturnType<Mutations[K]>
} & Omit<ActionContext<PermissionState, RootState>, 'commit'>

const hasPermission = (roles: string[], route: RouteRecordRaw) => {
  if (route.meta && route.meta.roles) {
    return roles.some(role => {
      if (route.meta?.roles !== undefined) {
        return route.meta.roles.includes(role)
      }
    })
  } else {
    return true
  }
}

export const filterAsyncRoutes = (routes: RouteRecordRaw[], roles: string[]) => {
  const res: RouteRecordRaw[] = []
  routes.forEach(route => {
    const r = { ...route }
    if (hasPermission(roles, r)) {
      if (r.children) {
        r.children = filterAsyncRoutes(r.children, roles)
      }
      res.push(r)
    }
  })
  return res
}

export interface Actions {
    [PermissionActionType.ACTION_SET_ROUTES](
      { commit }: AugmentedActionContext
      , roles: string[]): void
}

export const actions: ActionTree<PermissionState, RootState> & Actions = {
  async [PermissionActionType.ACTION_SET_ROUTES](
    { commit }: AugmentedActionContext
    , roles: string[]) {
    const accessedRoutes = filterAsyncRoutes(asyncRoutes, roles)
    /*
    await getCurrentUserMenu().then((res: RootObject<UserMenuModel[]> | null) => {
      if (res != null) {
        const routes = formatRouters(res.data)
        commit(PermissionMutationType.SET_ROUTES, routes)
      }
    }).catch(err => {
      throw Error(err?.msg)
    })
    */
    commit(PermissionMutationType.SET_ROUTES, accessedRoutes)
  }
}
